<template>
  <nav class="main-menu" :class="{ 'main-menu-mobile': mobile }">
    <div id="menu" v-show="menuIsVisivel">
      <div class="list-group">
        <div v-for="item in menuGerado" :key="item.label" class="opcoes">
          <RouterLink class="menu-btn" :class="{
            'opcao-selecionada': opcaoSelecionada === item.label,
          }" :to="`/${item.route}`" @click="handleMenuClick">
            {{ item.label }}
          </RouterLink>
        </div>

        <div class="search-wrapper" ref="searchRef">
          <input ref="searchInputRef" v-model="termoBusca" type="text" :disabled="!mobile && !buscaAberta" :class="[
            'search-input',
            { aberta: buscaAberta || mobile },
          ]" placeholder="Buscar..." @keyup.enter="buscar" />

          <img src="@/assets/lupa.png" alt="Buscar" class="lupa" :class="{ ativa: buscaAberta || mobile }"
            @click="handleClickLupa" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import {
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";

import { useRouter, useRoute, RouterLink } from "vue-router";

const props = defineProps({
  mobile: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["fechar-menu"]);

const route = useRoute();
const router = useRouter();

const menuIsVisivel = ref(true);
const opcaoSelecionada = ref("");

const buscaAberta = ref(false);
const termoBusca = ref("");

const searchRef = ref(null);
const searchInputRef = ref(null);

const menuGerado = [
  {
    label: "Ações",
    page: "acoes",
    route: "suas-acoes",
  },
  {
    label: "Atividades",
    page: "atividades",
    route: "Atividades",
  },
  {
    label: "Notícias",
    page: "noticias",
    route: "Noticias",
  },
  {
    label: "Vagas",
    page: "vagas",
    route: "vagas",
  },
  {
    label: "Parcerias",
    page: "parcerias",
    route: "Parcerias",
  },
  {
    label: "Painel da Extensão",
    page: "dashboard",
    route: "dashboard",
  },
];

function handleMenuClick() {
  if (props.mobile) {
    emit("fechar-menu");
  }
}


async function handleClickLupa() {
  if (props.mobile) {
    buscar();
    return;
  }

  if (!buscaAberta.value) {
    buscaAberta.value = true;

    await nextTick();

    searchInputRef.value?.focus();
  } else {
    buscar();
  }
}

function handleClickOutside(event) {
  if (
    searchRef.value &&
    !searchRef.value.contains(event.target)
  ) {
    buscaAberta.value = false;
  }
}

function buscar() {
  const termo = termoBusca.value.trim();

  if (!termo) return;

  router.push({
    path: "/resultados",
    query: {
      q: termo,
    },
  });

  buscaAberta.value = false;
  termoBusca.value = "";

  if (props.mobile) {
    emit("fechar-menu");
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

watch(
  () => route.path,
  (newPath) => {
    if (newPath === "/") {
      opcaoSelecionada.value = "";
      return;
    }

    const caminhoAtual = newPath.toLowerCase();

    const item = menuGerado.find((i) => {
      const routePath = `/${i.route.toLowerCase()}`;
      const pagePath = `/${i.page.toLowerCase()}`;

      return (
        caminhoAtual === routePath ||
        caminhoAtual.startsWith(`${routePath}/`) ||
        caminhoAtual === pagePath ||
        caminhoAtual.startsWith(`${pagePath}/`)
      );
    });

    opcaoSelecionada.value = item ? item.label : "";
  },
  {
    immediate: true,
  }
);
</script>

<style scoped>
.main-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.opcoes {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu-btn,
.admin {
  color: var(--branco);
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 12px;
  font-size: 0.9rem;
  border-radius: 15px;
  white-space: nowrap;
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
  text-decoration: none;
}

.menu-btn:hover,
.admin:hover {
  background-color: var(--roxo-primario);
}

.opcao-selecionada {
  background-color: var(--roxo-primario);
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-input {
  width: 0;
  padding: 0;
  border-radius: 15px;
  border: none;
  outline: none;
  opacity: 0;
  pointer-events: none;
  margin-left: 2rem;
  transition: all 0.2s ease;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-input.aberta {
  width: 250px;
  padding: 6px 35px 6px 10px;
  opacity: 1;
  pointer-events: auto;
  background: var(--branco);
  margin-left: 0;
  color: var(--cinza-escuro);
}

.lupa {
  position: absolute;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;
}

.lupa.ativa {
  filter: none;
}

/* Telas médias */
@media (max-width: 1200px) {
  .main-menu:not(.main-menu-mobile) .list-group {
    gap: 0.5rem;
  }

  .main-menu:not(.main-menu-mobile) .menu-btn {
    padding: 6px 10px;
  }

  .main-menu:not(.main-menu-mobile) .search-input:not(.aberta) {
    margin-left: 1rem;
  }
}

.main-menu-mobile {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px 24px 40px;
  box-sizing: border-box;
  z-index: 901;
}

.main-menu-mobile #menu {
  width: 100%;
}

.main-menu-mobile .list-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;
}

.main-menu-mobile .opcoes {
  width: 100%;
  display: block;
}

.main-menu-mobile .menu-btn {
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 12px 18px;
  border-radius: 14px;
  font-size: 1.05rem;
  font-weight: 500;
}

.main-menu-mobile .menu-btn:hover,
.main-menu-mobile .opcao-selecionada {
  background-color: var(--roxo-primario);
}

.main-menu-mobile .search-wrapper {
  width: 100%;
  min-height: 52px;
  margin-top: 12px;
  background: hsla(0, 0%, 100%, 0.12);
  border-radius: 14px;
}

.main-menu-mobile .search-input {
  width: 100%;
  height: 52px;
  margin: 0;
  padding: 6px 50px 6px 18px;
  opacity: 1;
  pointer-events: auto;
  background: transparent;
  color: var(--branco);
  font-size: 1rem;
}

.main-menu-mobile .search-input::placeholder {
  color: hsla(0, 0%, 100%, 0.75);
}

.main-menu-mobile .search-input:focus {
  background: var(--branco);
  color: var(--cinza-escuro);
}

.main-menu-mobile .search-input:focus::placeholder {
  color: var(--cinza-medio);
}

.main-menu-mobile .lupa {
  right: 17px;
  width: 21px;
  height: 21px;
}
</style>
